export function getVideoUrl() {
  return "https://dancing2me.s3.amazonaws.com/";
}

// handle user media capture
export function captureUserMedia(callback) {
  var params = {
    audio: false,
    video: true,
    width: 640,
    height: 480
  };

  navigator.getUserMedia(params, callback, (error) => {
    alert(JSON.stringify(error));
  });
};

export function generateID() {
  var s4;
  s4 = function () {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

// handle S3 upload
export function saveToDatabase(id, videoName, dancerName, dancerLocation, currentDance) {
  let queryString = '?id=' + encodeURIComponent(id) + '&videoName=' + encodeURIComponent(videoName) + '&dancerName=' + encodeURIComponent(dancerName) + '&dancerLocation=' + encodeURIComponent(dancerLocation);
  if (currentDance != null) {
    queryString += "&currentDance=" + currentDance;
  }
  return fetch('/video/save' + queryString)
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log('error: ', err)
    })
}

export function getDance(id) {
  let queryString = '?id=' + encodeURIComponent(id);
  return fetch('/video/get' + queryString)
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log('error: ', err)
    })
}

export function getDances(completed) {
  var url = "/view/incomplete";
  if (completed) {
    url = "/view/complete";
  }

  return fetch(url)
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log('error: ', err)
    })
}


export function getLatestDance() {
  var url = "/view/latest";


  return fetch(url)
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log('error: ', err)
    })
}

// handle S3 upload
function getSignedUrl(file) {
  let queryString = '?objectName=' + encodeURIComponent(file.id) + '&contentType=' + encodeURIComponent(file.type);
  return fetch('/s3/sign' + queryString)
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log('error: ', err)
    })
}

function createCORSRequest(method, url) {
  var xhr = new XMLHttpRequest();

  if (xhr.withCredentials != null) {
    xhr.open(method, url, true);
  } else if (typeof XDomainRequest !== "undefined") {
    xhr = new XDomainRequest();
    xhr.open(method, url);
  } else {
    xhr = null;
  }

  return xhr;
};

export function S3Upload(fileInfo) { //parameters: { type, data, id }
  return new Promise((resolve, reject) => {
    getSignedUrl(fileInfo)
      .then((s3Info) => {
        // upload to S3
        var xhr = createCORSRequest('PUT', s3Info.signedUrl);

        xhr.onload = function () {
          if (xhr.status === 200) {
            console.log(xhr.status)
            resolve(true);
          } else {
            console.log(xhr.status)

            reject(xhr.status);
          }
        };

        xhr.setRequestHeader('Content-Type', fileInfo.type);
        xhr.setRequestHeader('x-amz-acl', 'public-read');

        return xhr.send(fileInfo.data);
      })
  })
}

export function captureVideoFrame(video, format) {
  /*if (typeof video === 'string') {
      video = document.getElementById(video);
  }*/

  format = format || 'jpeg';

  if (!video || (format !== 'png' && format !== 'jpeg')) {
    alert("Could not capture video thumbnail :(");
    return false;
  }

  var canvas = document.createElement("CANVAS");

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  canvas.getContext('2d').drawImage(video, 0, 0);

  var dataUri = canvas.toDataURL('img/' + format);
  var data = dataUri.split(',')[1];
  var mimeType = dataUri.split(';')[0].slice(5)

  var bytes = window.atob(data);
  var buf = new ArrayBuffer(bytes.length);
  var arr = new Uint8Array(buf);

  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  var blob = new Blob([arr], {
    type: mimeType
  });
  return {
    blob: blob,
    dataUri: dataUri,
    format: format
  };
}


// WEBPACK FOOTER //
// src/AppUtils.js